import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Build a Chrome extension from idea to launch in an afternoon",
  "description": "",
  "published": "2018-03-13T00:00:00.000Z",
  "redirect_from": ["/blog/build-chrome-extension/swizec/8278"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should subscribe to `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "I7ibjBQtcQE",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`One of my most pointless timesucks is `}<a parentName="p" {...{
        "href": "https://imgur.com"
      }}>{`imgur.com`}</a>{`.`}</p>
    <p>{`Maybe you don't know what that is, or think it's an image host for Reddit and never realized it's got a homepage. `}<a parentName="p" {...{
        "href": "https://www.buzzfeed.com/jwherrman/imgur-is-now-bigger-than-reddit"
      }}>{`Imgur is bigger than Reddit`}</a>{`, actually.`}</p>
    <p>{`That's news from 5 years ago. 🤔 Am I not hip with the kids anymore?`}</p>
    <p><img parentName="p" {...{
        "src": "/09e34cd734909d10f024c227c0adac66/media-ifxLK48cnyDDi-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Either way, Imgur is great. Full of fun images, crap comments, and there's always the next gif to see. Sometimes world news.`}</p>
    <p>{`You open it up, it greets you with enticing thumbnails and before you know it, it's 20 minutes later and you're waaaaay past your break time.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/imgur_home_page-3.png",
        "alt": null
      }}></img></p>
    <p>{`I built `}<a parentName="p" {...{
        "href": "#"
      }}>{`hideimgur.com`}</a>{` to fix that. It’s a Chrome extension that replaces Imgur's homepage with tips for taking a healthy break. Sometimes it tells you to do push ups, sometimes to go chat with a human being. It's great.`}</p>
    <p>{`And no more imgur addiction. Fixed me in 2 days! 👌`}</p>
    <p><a parentName="p" {...{
        "href": "http://hideimgur.com"
      }}>{`[`}{`caption id="attachment_8274" align="alignnone" width="2178"`}{`]`}<img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2018/03/hide-imgur-homepage-1.png",
          "alt": "HideImgur replaces the homepage with useful tips"
        }}></img>{` HideImgur replaces the homepage with useful tips`}{`[`}{`/caption`}{`]`}</a></p>
    <p>{`You can see `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/hide-imgur-homepage"
      }}>{`the code on GitHub`}</a>{` and watch the `}<a parentName="p" {...{
        "href": "#"
      }}>{`livecoding video 👆`}</a>{` to see how it's built.`}</p>
    <p>{`Here's the process for building and launching your Chrome extension in a nutshell. 👇`}</p>
    <h2 {...{
      "id": "create-an-extension"
    }}>{`Create an extension`}</h2>
    <p><a parentName="p" {...{
        "href": "https://developer.chrome.com/extensions/getstarted"
      }}>{`Google's official getting started tutorial`}</a>{` is great. You should skim it whenever you get stuck.`}</p>
    <p>{`First, you'll need to create a directory and a `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "manifest_version": 2,
    "name": "Hide imgur homepage",
    "version": "1.1",
    "description":
        "Replace the Imgur homepage with tips for taking a healthy break. New tip every time you slack.",
    "icons": {
        "16": "icon16.png",
        "48": "icon48.png",
        "128": "icon128.png"
    },
    "content_scripts": [
        {
            "matches": ["*://imgur.com/*"],
            "js": ["hide-imgur.js"],
            "css": ["hide-imgur.css"],
            "run_at": "document_start"
        }
    ],
    "permissions": ["tabs", "*://imgur.com/*"]
}
`}</code></pre>
    <p>{`It's a JSON config file that tells Chrome how your extension is supposed to work. The important parts are 👇`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`manifest_version`}</inlineCode>{`, `}<inlineCode parentName="li">{`name`}</inlineCode>{`, and `}<inlineCode parentName="li">{`version`}</inlineCode>{` are all required. You need those for your extension to work at all.`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`description`}</inlineCode>{` is useful but not crazy important. I'm not even sure where it shows up for the user.`}</li>
      <li parentName="ol">{`You need 3 `}<inlineCode parentName="li">{`icons`}</inlineCode>{` for various places Chrome puts them. You should make a simple image and resize it to 16x16, 48x48, and 128x128 pixels.`}</li>
    </ol>
    <p>{`You've created a Chrome extension! Congratz 🖐`}</p>
    <p>{`Not very useful yet. I wanted mine to get permissions for `}<inlineCode parentName="p">{`imgur.com`}</inlineCode>{` and run `}<inlineCode parentName="p">{`content_scripts`}</inlineCode>{` when you open that page.`}</p>
    <p>{`That's defined in `}<inlineCode parentName="p">{`content_scripts`}</inlineCode>{` and `}<inlineCode parentName="p">{`permissions`}</inlineCode>{`. The first tells Chrome which files to load when the URL matches `}<inlineCode parentName="p">{`imgur.com`}</inlineCode>{` and when it should run.`}</p>
    <p><inlineCode parentName="p">{`document_start`}</inlineCode>{` lets you run scripts `}<em parentName="p">{`before`}</em>{` the page is loaded. Avoids a lot of content flicker.`}</p>
    <p><inlineCode parentName="p">{`permissions`}</inlineCode>{` aspecifies which permsissinos you want to ask for. The fewer you ask for the more your users will like you.`}</p>
    <p>{`Nobody likes to see that "X asks for permission to access all your sites" notifications. Are you a keylogger?`}</p>
    <p>{`PS: You could totally build a keylogger like this. Please don't.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/permissions-screenshot-3.png",
        "alt": "Hideimgur.com asks for permissions to imgur"
      }}></img></p>
    <h2 {...{
      "id": "write-some-javascript"
    }}>{`Write some JavaScript`}</h2>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://developer.chrome.com/extensions/devguide"
      }}>{`do a lot of things with Chrome extensions`}</a>{`. Everything from changing the default new tab to adding window dialogs.`}</p>
    <p>{`For Imgur hiding, we need a content script. It’s the simplest Chrome extension to build, I think. A JavaScript file that runs in the context of a page.`}</p>
    <p>{`The fun part is avoiding frameworks.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/building-interactive-dom-benchmark-preliminary-results/swizec/8219"
      }}>{`DOM is fast these days`}</a>{` and pretty easy to use. Here's a function that hides an element on the page whether it's loaded yet or not. Remember, we're running `}<em parentName="p">{`before`}</em>{` the DOM is done loading.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// hide-imgur.js
function hideElement(query) {
  let el = document.querySelector(query);
  if (el) {
    el.style.visibility = "hidden";
    return true;
  } else {
    return false;
  }
}

function hideAsync(query) {
  const hidden = hideElement(query);

  if (!hidden) {
    setTimeout(function () {
      hideAsync(query);
    }, 100);
  } else {
    putUpSomeContent();
  }
}
`}</code></pre>
    <p>{`In `}<inlineCode parentName="p">{`hideElement`}</inlineCode>{`, we look for a DOM node. If it's found, we set its `}<inlineCode parentName="p">{`visibility`}</inlineCode>{` to `}<inlineCode parentName="p">{`hidden`}</inlineCode>{` and return `}<inlineCode parentName="p">{`true`}</inlineCode>{`. Otherwise, we say nothing happened.`}</p>
    <p>{`It's important to toggle visibility instead of the usual `}<inlineCode parentName="p">{`display: none`}</inlineCode>{` because it avoids removing the node, just hides it. We want to avoid removing the node because if we collapse the page to zero height, Imgur's infinite scroll falls into an infinite loop and eats all our CPU.`}</p>
    <p>{`That was fun to discover 😅`}</p>
    <p><inlineCode parentName="p">{`hideAsync`}</inlineCode>{` is a wrapper on top of `}<inlineCode parentName="p">{`hideElement`}</inlineCode>{` that waits until nodes are rendered before hiding them. Takes a query, calls `}<inlineCode parentName="p">{`hideElement`}</inlineCode>{`, if nothing happens it waits `}<inlineCode parentName="p">{`100`}</inlineCode>{` milliseconds then tries again.`}</p>
    <p>{`If hiding worked, it runs the function that puts healthy tips on the page.`}</p>
    <p>{`Finally, we loop through all distracting elements of Imgur and hide them in a loop 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// hide-imgur.js

// Go through dangerouns elements and hide them
[
  "#imagelist",
  "#top-comments",
  ".sentence-sorting",
  "#right-content",
  "#extended-imagelist",
  ".next-prev",
].forEach(hideAsync);
`}</code></pre>
    <p>{`You can find those elements with the Elements tab of your Chrome dev tools. The key is to find the topmost node that wraps all the content, but doesn't wrap too much of the content.`}</p>
    <p>{`Bit of an art. And it's gonna break when Imgur redesigns.`}</p>
    <p>{`The definition of fragile code 😛`}</p>
    <p><img parentName="p" {...{
        "src": "/67fcfea55136d940c91a282130bd3866/media-Xra0ADZp25hBK-giphy.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "launch"
    }}>{`Launch`}</h2>
    <p>{`Launching your extension takes you to one of the worst designed websites I have ever seen: The `}<a parentName="p" {...{
        "href": "https://chrome.google.com/webstore/developer/dashboard?pli=1&authuser=1"
      }}>{`Chrome Web Store Developers Dashboard`}</a></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/Screen-Shot-2018-03-13-at-09.55.39-3.png",
        "alt": null
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "https://developer.chrome.com/webstore/publish"
      }}>{`Detailed instructions in Google's devguide`}</a></p>
    <p>{`You pay a $5 fee the first time you publish, upload a zip file of your directory, add some descriptions and screenshots, and you're off to the races.`}</p>
    <p>{`Next time you search Chrome extensions, your baby will be there.`}</p>
    <p><a parentName="p" {...{
        "href": "http://hideimgur.com"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2018/03/Screen-Shot-2018-03-13-at-09.42.44-1-1024x126.png",
          "alt": null
        }}></img></a></p>
    <p>{`🤘`}</p>
    <p>{`PS: It helps to make a nice landing page before you post to ProductHunt and places like that. I used `}<a parentName="p" {...{
        "href": "https://carrd.co"
      }}>{`carrd.co`}</a>{` to do that.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      